import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TeacherLmsSidebar from "./components/TeacherLmsSidebar";
import LmsTopbar from "./components/LmsTopbar";
import "./lms.css";

export default function TeacherLmsLayout() {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, []);

  const handleOverlayClick = () => setSidebarOpen(false);

  return (
    <div className="lms-shell">
      {sidebarOpen && (
        <div className="lms-sidebar-overlay" onClick={handleOverlayClick} />
      )}

      <TeacherLmsSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="lms-main">
        <LmsTopbar
          onUploadClick={() => setUploadModalOpen(true)}
          onMenuClick={() => setSidebarOpen((o) => !o)}
        />

        <main className="lms-content">
          <Outlet context={{ uploadModalOpen, setUploadModalOpen }} />
        </main>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    </div>
  );
}
